import EventCreate from './EventCreate';

export default EventCreate;
